'use client';
import { createSafeHeaders } from './createSafeHeaders.js';

const mergeHeaders = (sourceA = {}, sourceB = {})=>{
    const result = createSafeHeaders(sourceA);
    const source = createSafeHeaders(sourceB);
    const isHeadersInstance = sourceB instanceof globalThis.Headers;
    for (const [key, value] of source.entries()){
        if (isHeadersInstance && value === 'undefined' || value === undefined) {
            result.delete(key);
        } else {
            result.set(key, value);
        }
    }
    return result;
};

export { mergeHeaders };
//# sourceMappingURL=mergeHeaders.js.map
